<template>
  <div class="honer">
    <div style="display: flex; align-items: flex-end; padding: 5px 0 0px 20px">
      <h2>个人所获荣誉列表</h2>
      <span style="color: rgba(16, 16, 16, 100); font-size: 14px"
        >&nbsp; 请按获奖时间从远到近上传获奖信息</span
      >
    </div>
    <div class="sub">
      <el-button type="primary" @click="add">添加证书</el-button>
    </div>
    <el-form
      :rules="rules"
      ref="ruleForm"
      :model="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div
        style="display: flex; flex-wrap: wrap"
        class="border"
        v-for="(item, index) in ruleForm.form"
        :key="index"
      >
        <el-form-item
          label="荣誉级别"
          :prop="'form.' + index + '.level'"
          :rules="rules.level"
        >
          {{ item.level }}
          <el-select
            v-model="item.level"
            placeholder="请选择荣誉级别"
            style="width: 100%"
          >
            <el-option label="1" value="17"></el-option>
            <el-option label="2" value="27"></el-option>
          </el-select>
        </el-form-item>
        {{ item.company }}
        <el-form-item
          label="主办单位"
          :prop="'form.' + index + '.company'"
          :rules="rules.company"
        >
          <el-select
            v-model="item.company"
            placeholder="请选择主办单位"
            style="width: 100%"
          >
            <el-option label="南京" value="1"></el-option>
            <el-option label="上海" value="2"></el-option>
          </el-select>
        </el-form-item>
        {{ item.name }}
        <el-form-item
          label="荣誉全称"
          :prop="'form.' + index + '.name'"
          :rules="rules.name"
        >
          <el-select
            v-model="item.name"
            placeholder="请选择活动区域"
            style="width: 100%"
          >
            <el-option label="区域1" value="1"></el-option>
            <el-option label="区域2" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="所属领域"
          :prop="'form.' + index + '.field'"
          :rules="rules.field"
        >
          {{ item.field }}
          <el-select
            v-model="item.field"
            placeholder="请选择所属领域"
            style="width: 100%"
          >
            <el-option label="领域一" value="1"></el-option>
            <el-option label="领域二" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="获取时间"
          :prop="'form.' + index + '.time'"
          :rules="rules.time"
          >{{ item.time }}
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="item.time"
            style="width: 100%"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="荣誉证书"
          style="width: 100%"
          :prop="'form.' + index + '.imageUrl'"
          :rules="rules.imageUrl"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            accept="image/*"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onChangeImg"
          >
            <img v-if="imageUrl" :src="ruleForm.imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="annotations">请上传jpg/png格式的尺寸为300：400的蓝底照片</div>
        </el-form-item>
      </div>
      <el-button
        type="primary"
        ref="rongyu"
        @click="submitForm('ruleForm')"
        style="display: none"
        >立即创建</el-button
      >
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: 1,
      imageUrl: false,
      ruleForm: {
        form: [
          {
            level: "", //级别
            company: "", //单位
            name: "", //全称
            field: "", //领域
            time: "", //时间
            imageUrl: "证书地址", //证书
          },
        ],
      },
      rules: {
        level: [{ required: true, message: "请选择", trigger: "change" }],
        company: [{ required: true, message: "请选择", trigger: "change" }],
        name: [{ required: true, message: "请选择", trigger: "change" }],
        field: [{ required: true, message: "请选择", trigger: "change" }],
        time: [{ required: true, message: "请选择", trigger: "change" }],
        imageUrl: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  methods: {
    add() {
      this.ruleForm.form.push({
        level: "", //级别
        company: "", //单位
        name: "", //全称
        field: "", //领域
        time: "", //时间
        imageUrl: "证书", //证书
      });
    },
    submitForm(formName) {
      // console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.$emit("honor", this.ruleForm.form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    subClick() {
      this.$refs.rongyu.$el.click();
    },
    // 平台logo上传
    onChangeImg(file) {
      this.loading = true;
      this.uploadImgToOss(file)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.logo = res.data.data;
            console.log(this.logo);
            // this.getPlatformConfigList();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.honer {
  height: 100%;
  width: 100%;

  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid #e4e7ed;
  //   padding: 20px 20px;
  display: flex;
  flex-direction: column;
  .demo-ruleForm {
    padding: 0 0 0 10px;
    flex: 1;
    overflow-y: scroll;
  }
}
/deep/.el-input__inner {
  height: 36px;
}
.sub {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
  margin-right: 10px;
  /deep/.el-button {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0.7rem 0.8rem;
    border: none;
  }
}
.el-form-item {
  width: 30%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 83px;
  height: 83px;
  line-height: 83px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 83px;
  height: 83px;
  display: block;
}
.annotations {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
/deep/.el-form-item {
  margin-bottom: 15px;
}

.border {
  border: 1px solid #e4e7ed;
  padding-top: 10px;
  margin-bottom: 5px;
}
</style>